module.exports = __webpack_public_path__ + "static/media/helga.82d4563e.jpg";